import { inject, Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef, TextOnlySnackBar } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root'
})
export class NotificationService  {
    private readonly _snackBar = inject(MatSnackBar);

    public openText(text: string, duration: number = 5000): MatSnackBarRef<TextOnlySnackBar> {
        return this._snackBar.open(text, undefined, {
            duration
        });
    }

    public openError(text: string, duration: number = 5000): MatSnackBarRef<TextOnlySnackBar> {
        return this._snackBar.open(text, undefined, {
            duration,
            panelClass: 'snackbar-error'
        });
    }
}